import { render, staticRenderFns } from "./sj-editor-old.vue?vue&type=template&id=5debb8ea&scoped=true"
import script from "./sj-editor-old.vue?vue&type=script&lang=js"
export * from "./sj-editor-old.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5debb8ea",
  null
  
)

export default component.exports